import { computed, type ComputedRef } from 'vue'
import type { QSectionProps } from './use-section-props'

interface PropsData {
  classes?: string[]
  [key: string]: any
}

/**
 * 合并类名的 composable
 */
export function useSectionClasses(props: QSectionProps, propsData: ComputedRef<PropsData>) {
  const mergedClasses = computed(() => {
    const classes = ['q-section']

    // 处理 class 属性
    if (props.class) {
      if (Array.isArray(props.class)) {
        classes.push(...props.class)
      } else {
        classes.push(props.class)
      }
    }

    // 处理 uiMeta 中的 classes
    if (propsData.value.classes) {
      classes.push(...propsData.value.classes)
    }

    return classes
  })

  return {
    mergedClasses,
  }
}
